/**
 * @fileoverview O começo do assistente para quem ainda não confirmou o e-mail
 * (etapa 12 dos planos): a IA usa um projeto da OpenAI pago pela Sttelar, que só
 * nasce com o e-mail confirmado (o servidor recusa antes disso). A espera pela
 * confirmação está em useEmailConfirmation.
 */

import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { MailCheck, Send } from "lucide-react";

import { useEmailConfirmation } from "../../hooks/useEmailConfirmation";
import { i18n } from "../../translate/i18n";
import { useAuthFormStyles } from "../AuthLayout/formStyles";
import { useAiSetupStyles } from "./styles";

const t = (key, options) => i18n.t(`aiSetup.confirmEmail.${key}`, options);

const ConfirmEmailCard = ({ email, onConfirmed }) => {
  const classes = useAiSetupStyles();
  const form = useAuthFormStyles();
  const { check, resend, checking, sending, notice, error } = useEmailConfirmation({ email, onConfirmed });

  return (
    <div className={classes.card}>
      <h2 className={classes.cardTitle}>
        <span className={classes.iconBox}><MailCheck size={17} /></span>
        {t("title")}
      </h2>
      <p className={classes.cardText}>{t("text", { email })}</p>
      {notice && <div className={form.notice} role="status">{notice}</div>}
      {error && <div className={`${form.notice} ${form.noticeBad}`} role="alert">{error}</div>}
      <button type="button" className={form.button} onClick={check} disabled={checking}>
        {checking && <CircularProgress size={18} className={form.spinner} />}
        {t("check")}
      </button>
      <div className={classes.divider}>{i18n.t("aiSetup.source.or")}</div>
      <button type="button" className={classes.textButton} onClick={resend} disabled={sending}>
        <Send size={15} /> {t("resend")}
      </button>
    </div>
  );
};

export default ConfirmEmailCard;
